module.exports = __webpack_public_path__ + "static/img/icp.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icp.png
// module id = bSj4
// module chunks = 29